// src/useAnalytics.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_TRACKING_ID = "G-ES852FMF04";

const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      const pagePath = window.location.hash
        ? window.location.hash.substring(1) // removes #
        : location.pathname;

      window.gtag("config", GA_TRACKING_ID, {
        page_path: pagePath,
      });
    }
  }, [location]);
};

export default useAnalytics;
